import React, {useState, useEffect, useContext} from "react";
import "../../assets/stylesheets/contacts.css";
import whatsappIcon from "../../assets/image/whatsapp.svg";
import messengerIcon from "../../assets/image/messenger.svg";
import viberIcon from "../../assets/image/viber.svg";
import phoneIcon from "../../assets/image/phone.svg";
import telegramIcon from "../../assets/image/telegram.svg";
import axios from "axios";
import Modal from "react-modal";
import Logo from "../../assets/image/logo.svg";
import {useTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import { ReactComponent as LocationIcon } from '../../assets/image/location2.svg';
import { ReactComponent as GmailIcon } from '../../assets/image/gmail2.svg';
import { ReactComponent as PhoneIcon } from '../../assets/image/phone2.svg';
import i18n from 'i18next';
import {toast} from "react-toastify";
import {FaTimes} from "react-icons/fa";
import {ContactInfoContext} from "../additional/ContactInfoContext";

function Contacts() {
    const {t} = useTranslation(["data"]);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [formErrors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        firstName: "",
        secondName: "",
        email: "",
        phoneNumber: "",
        message: "",
    });
    const { contactInfo } = useContext(ContactInfoContext);

    const handleChange = (e) => {
        const {id, value} = e.target;
        setFormData((prev) => ({...prev, [id]: value}));
        setErrors((prev) => ({...prev, [id]: ""}));
    };

    const validate = () => {
        const errors = {};
        if (!formData.firstName.trim()) {
            errors.firstName = t("contactForm.errors.firstName");
        }
        if (!formData.secondName.trim()) {
            errors.secondName = t("contactForm.errors.secondName");
        }
        if (!formData.email.trim()) {
            errors.email = t("contactForm.errors.emailRequired");
        } else if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(formData.email)) {
            errors.email = t("contactForm.errors.emailInvalid");
        }
        if (!formData.phoneNumber.trim()) {
            errors.phoneNumber = t("contactForm.errors.phoneNumber");
        }
        if (!formData.message.trim()) {
            errors.message = t("contactForm.errors.message");
        }
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setIsSubmitting(true);
        try {

            await axios.post(`${process.env.REACT_APP_MY_API_KAY}/contact/real-estate`, null, {
                params: formData,
            });

            toast.success(t("contactForm.success"), {
                position: "top-center", // 👈 Centered on screen
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                style: {
                    background: "#115772", // 👈 Your custom color
                    color: "#fff",         // Text color
                    fontWeight: "bold",
                    fontSize: "16px",
                    borderRadius: "8px",
                },
            });

            setFormData({
                firstName: "",
                secondName: "",
                email: "",
                phoneNumber: "",
                message: "",
            });
            setIsOpen(true);
        } catch (error) {
            console.error("Error sending message:", error);
            setErrors({submit: t("contactForm.errors.submitFailed")});
        } finally {
            setIsSubmitting(false);
        }
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    return (
        <>
            <Helmet>
                <link
                    rel="canonical"
                    href={`https://sievn.am/${i18n.language}/contacts`}
                />
                <meta
                    property="og:url"
                    content={`https://sievn.am/${i18n.language}/contacts`}
                />
                <meta property="og:title" content={t("contactTitle")}/>
                <meta property="og:site_name" content="sievn.am"/>
                <meta property="og:description" content={t("contact_desc")}/>
                <meta property="og:image" content={Logo}/>
                <meta property="og:image:width" content="1200"/>
                <meta property="og:image:height" content="630"/>
                <meta name="description" content={t("contact_desc")}/>
                <title>{t("contactTitle")} </title>
            </Helmet>
            <section className="contactpage">
                <div className="contact__container">
                    <div className="contact__form">
                        <h1 className="contact__form-title">{t("callUs")} </h1>
                        <div className="contact__icons">
                            {contactInfo.wpPhone && (
                                <a
                                    target="_blank"
                                    href={`https://api.whatsapp.com/send?phone=${contactInfo.wpPhone}`}
                                    className="contact__icon-item whatsapp"
                                    rel="noopener noreferrer"
                                >
                                    <img src={whatsappIcon} alt="whatsapp"/>
                                </a>
                            )}
                            {/*{contactInfo.viberPhone && (*/}
                            {/*    <a*/}
                            {/*        target="_blank"*/}
                            {/*        href={`https://msng.link/o/?${contactInfo.viberPhone}=vi`}*/}
                            {/*        className="contact__icon-item viber"*/}
                            {/*        rel="noopener noreferrer"*/}
                            {/*    >*/}
                            {/*        <img src={viberIcon} alt="viber"/>*/}
                            {/*    </a>*/}
                            {/*)}*/}
                            {contactInfo.tgUsername && (
                                <a
                                    target="_blank"
                                    href={`https://t.me/${contactInfo.tgUsername}`}
                                    className="contact__icon-item telegram"
                                    rel="noopener noreferrer"
                                >
                                    <img src={telegramIcon} alt="telegram"/>
                                </a>
                            )}
                            {contactInfo.messenger && (
                                <a
                                    target="_blank"
                                    href={contactInfo.messenger}
                                    className="contact__icon-item messenger"
                                    rel="noopener noreferrer"
                                >
                                    <img src={messengerIcon} alt="messenger"/>
                                </a>
                            )}
                            {contactInfo.telPhone && (
                                <a
                                    href={`tel:${contactInfo.telPhone}`}
                                    className="contact__icon-item phone"
                                >
                                    <img src={phoneIcon} alt="phone"/>
                                </a>
                            )}
                        </div>
                        <h3 className="contact__form-text">{t("contactText")} </h3>
                        <form onSubmit={handleSubmit} className="contact__form-group">
                            <div className="contact-form-field">
                                <input
                                    className="contact-form-input"
                                    type="text"
                                    id="firstName"
                                    placeholder={t("contactForm.placeholders.firstName")}
                                    value={formData.firstName}
                                    onChange={handleChange}
                                />
                                {formErrors.firstName && (
                                    <p className="contact-form-error">{formErrors.firstName} </p>
                                )}
                            </div>
                            <div className="contact-form-field">
                                <input
                                    className="contact-form-input"
                                    type="text"
                                    id="secondName"
                                    placeholder={t("contactForm.placeholders.secondName")}
                                    value={formData.secondName}
                                    onChange={handleChange}
                                />
                                {formErrors.secondName && (
                                    <p className="contact-form-error">{formErrors.secondName} </p>
                                )}
                            </div>
                            <div className="contact-form-field">
                                <input
                                    className="contact-form-input"
                                    type="email"
                                    id="email"
                                    placeholder={t("contactForm.placeholders.email")}
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                                {formErrors.email && (
                                    <p className="contact-form-error">{formErrors.email} </p>
                                )}
                            </div>
                            <div className="contact-form-field">
                                <input
                                    className="contact-form-input"
                                    type="text"
                                    id="phoneNumber"
                                    placeholder={t("contactForm.placeholders.phoneNumber")}
                                    value={formData.phoneNumber}
                                    onChange={handleChange}
                                />
                                {formErrors.phoneNumber && (
                                    <p className="contact-form-error">{formErrors.phoneNumber} </p>
                                )}
                            </div>
                            <div className="contact-form-field">
                <textarea
                    className="contact-form-textarea"
                    id="message"
                    rows="10"
                    placeholder={t("contactForm.placeholders.message")}
                    value={formData.message}
                    onChange={handleChange}
                />
                                {formErrors.message && (
                                    <p className="contact-form-error">{formErrors.message} </p>
                                )}
                            </div>
                            {formErrors.submit && (
                                <p className="contact-form-error">{formErrors.submit} </p>
                            )}
                            <button
                                className="contact-form-submit"
                                type="submit"
                                disabled={isSubmitting}
                            >
                                {isSubmitting
                                    ? t("contactForm.submitting")
                                    : t("contactForm.submit")}
                            </button>
                        </form>
                        <Modal
                            isOpen={modalIsOpen}
                            onRequestClose={closeModal}
                            contentLabel="Contact Success Modal"
                            overlayClassName="estate-contact-overlay"
                            className="estate-contact-content"
                        >

                            <FaTimes
                                className="estate-contact-close"
                                onClick={closeModal}
                            />

                            <div className="estate-contact-header">
                                <h2 className="estate-contact-title">
                                    {t("contactForm.successTitle")}
                                </h2>
                            </div>
                            <p className="estate-contact-info">{t("contactForm.success")} </p>
                        </Modal>
                    </div>
                    <div className="contact__map">
                        <div className="contact__map-img">
                            <div className="google-map-code">
                                <iframe
                                    src={contactInfo.googleMapsUrl}
                                    frameBorder="0"
                                    style={{border: 0}}
                                    allowFullScreen=""
                                    aria-hidden="false"
                                    tabIndex="0"
                                ></iframe>
                            </div>
                        </div>
                        <div className="contact__map-info">
                            <div className="contact__map-item">
                                <LocationIcon style={{ fill: '#115772' }} />
                                <a href="#">{contactInfo.address || t("address")} </a>
                            </div>
                            <div className="contact__map-item">
                                <GmailIcon style={{ fill: '#115772' }} />
                                <a href={`mailto:${contactInfo.email}`}>
                                    {contactInfo.email || "info@sievn.am"}
                                </a>
                            </div>
                            <div className="contact__map-item">
                                <PhoneIcon style={{ fill: '#115772' }} />
                                <a href={`tel:${contactInfo.telPhone}`}>
                                    {contactInfo.telPhone || t("phone")}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Contacts;